<template>
  <div class="page">
    <sunset-note-stats-query-bar
        v-slot="{ params, meta, query, currentUser }"
        path-base="/sunset/reports/note-stats/totals"
    >
      <section v-if="currentUser">
        <h2>
          User stats for {{currentUser.user_name}}
        </h2>

        <NoteStatsCsvButton mode="totals-user" :params="params" :query="query" />

        <NotesQuickLink mode="notes-user" :params="params" :query="query" />

        <!-- refactored: pass single-source params/meta/query -->
        <UserTotalsTable :params="params" :meta="meta" :query="query" />
      </section>
    </sunset-note-stats-query-bar>
  </div>
</template>

<script>
import UserTotalsTable from './components/user_totals/user_totals.vue';
import loadingCube from 'loaders/record_loader.vue';
import SunsetNoteStatsQueryBar from 'pages/sunset/reports/notestats/components/shared/query_controls.vue';
import NotesQuickLink from './components/shared/notes_link_button.vue';
import NoteStatsCsvButton from 'pages/sunset/reports/notestats/components/shared/csv_button.vue';

export default {
  name: 'aggregated_summary_page',
  components: {
    NoteStatsCsvButton,
    SunsetNoteStatsQueryBar,
    loadingCube,
    UserTotalsTable,
    NotesQuickLink,
  },
};
</script>

<style lang="scss">
</style>
